/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Modal,
  Menu,
  MenuItem,
  Dialog,
} from "@material-ui/core";
import { ArrowDownward, ArrowUpward, Dehaze, MoreVert } from "@material-ui/icons";
import { orderBy } from "lodash";
import { FormattedMessage } from "react-intl";
import Pagination from "@material-ui/lab/Pagination";

import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";

import BackButton from '../../components/BackButton';
import { useDepartments } from "../../modules/dictionaries/shared";
import UserInputForm from "./helpers/UserInputForm";
import { styles } from "./constants/styles";
import { tableConfig } from "./constants/dataMockUp";
import { ASCENDING_ORDER, DESCENDING_ORDER, INITIAL_SORTING_ID, ROWS_PER_PAGE } from "./constants/constants";
import messages from "./constants/messages";
import { ModalState } from "./constants/types";
import { useAdministration, User, useAdminDepartment, Department } from "../../modules/admin";
import { useEffect } from "react";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import moment from "moment";
import cn from "classnames";
import ExportButtons from "../../modules/export/components/ExportButtons";
import XLSIcon from "../../icons/office/XLS";
import PDFIcon from "../../icons/office/PDF";
import { ExportType } from "../../modules/export/shared/services/ExportService";
import { useExport } from "../../modules/export/shared/hooks/useExport";
import { useIsAdmin } from "../../modules/user";
import { Redirect } from "react-router";

type Props = WithStyles<typeof styles>;

const AdminBlockPage: React.FC<Props> = (props: Props) => {
  const [idToSortByOrder, setIdToSortByOrder] = React.useState<[string, any]>([INITIAL_SORTING_ID, ASCENDING_ORDER]);
  const [currentPage, setCurrentPage] = React.useState<number>(0);
  const [modalState, setModalState] = React.useState<ModalState>({ open: false, variant: "", rowId: null });
  const [users, , getUsersList, , , deleteUser] = useAdminDepartment();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogRow, setDialogRow] = React.useState<User | null>(null);
  const [, , getExportUsersResult] = useExport();
  const [, departmentsWithNamesDeleted] = useDepartments();
  const [isAdmin] = useIsAdmin();

  const { classes } = props;
  const unsortedRows = users;
  useEffect(() => {
    getUsersList();
  }, [getUsersList]);

  const getDepartment = (id: number) => {
    const department = departmentsWithNamesDeleted.find((depart) => depart.id === id);
    if (department) {
      return department.name;
    }
    return `${id}`;
  };

  const handleSortClick = (id: string) => () => {
    const order = defineSortingOrder(id);
    if (order) {
      setIdToSortByOrder([id, order]);
    } else {
      setIdToSortByOrder([INITIAL_SORTING_ID, ASCENDING_ORDER]);
    }
  };

  const defineSortingOrder = (id: string) => {
    if (id !== idToSortByOrder[0]) {
      return ASCENDING_ORDER;
    }
    if (idToSortByOrder[1] === ASCENDING_ORDER) {
      return DESCENDING_ORDER;
    }
    if (idToSortByOrder[1] === DESCENDING_ORDER) {
      return false;
    }
  };

  const sortRowsById = () => {
    return orderBy(
      unsortedRows,
      [
        (row) => {
          if (idToSortByOrder[0] === "departmentId") {
            return getDepartment(row[idToSortByOrder[0]]).toLowerCase();
          }
          return row[idToSortByOrder[0]].toLowerCase();
        },
      ],
      [idToSortByOrder[1]],
    );
  };

  const closeModal = () => {
    setModalState({ open: false, variant: "", rowId: null });
  };

  const openAddForm = () => {
    setModalState({ open: true, variant: "add", rowId: null });
  };

  const openEditForm = (rowId: number, close: () => void) => () => {
    setModalState({ open: true, variant: "edit", rowId });
    close();
  };

  const handleOpenDialog = (row: User, close: () => void) => () => {
    setDialogRow(row);
    setDialogOpen(true);
    close();
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleDeleteNews = () => {
    if (dialogRow && dialogRow.id) {
      deleteUser(dialogRow.id);
    }
    setDialogOpen(false);
  };

  const handleClickExport = (exportType: ExportType) => {
    getExportUsersResult(exportType);
  };

  const getCurrentPage = (event: any, page: number) => {
    const pageToSet = page - 1;
    setCurrentPage(pageToSet);
  };

  const rows = sortRowsById();

  return (
    <Layout>
      <Header />
      {isAdmin === false && <Redirect from="*" to="/" />}
      <div className={classes.root}>
        <div className={classes.header}>
          <BackButton/>
          <Typography className={classes.headerTitle}>
            <FormattedMessage {...messages.header} />
          </Typography>
        </div>
        <div className={classes.buttonBase}>
          <Button variant="contained" onClick={openAddForm} color="primary" style={{textTransform: "none"}}>
            <FormattedMessage {...messages.addUserButton} />
          </Button>
          <Modal open={modalState.open && modalState.rowId === null} onClose={closeModal} className={classes.modal}>
            <UserInputForm variant={modalState.variant} handleCancel={closeModal} />
          </Modal>
        </div>
        <div className={classes.tableContainer}>
          <TableContainer component={"div"}>
            <Table key={`table-sortBy${idToSortByOrder.join("")}`} size="small">
              <TableHead>
                <TableRow>
                  {tableConfig.columns.map((column) => (
                    <TableCell key={column.id}>
                      <div>
                        {column.name}
                        {column.id !== "control" && (
                          <IconButton disableRipple size="small" onClick={handleSortClick(column.id)}>
                            {idToSortByOrder[0] !== column.id ||
                            (idToSortByOrder[0] === INITIAL_SORTING_ID && idToSortByOrder[1] === DESCENDING_ORDER) ? (
                              <ArrowUpward fontSize="small" />
                            ) : idToSortByOrder[1] === ASCENDING_ORDER ? (
                              <ArrowDownward fontSize="small" />
                            ) : (
                              <Dehaze fontSize="small" />
                            )}
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(currentPage * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE + ROWS_PER_PAGE)
                  .map((row: any) => (
                    <TableRow key={row.id}>
                      {tableConfig.columns.map((column) => (
                        <TableCell
                          key={`${row.id}#${column.id}`}
                          classes={{
                            root: cn(classes.tableCell, {
                              [classes.tableCellMinWidth]: column.id === "name" || column.id === "surname",
                              [classes.tableCellWidth]: column.id === "registrationDate",
                            }),
                          }}
                        >
                          {column.id === "control" ? (
                            <>
                              <PopupState variant="popover" popupId="demo-popup-menu">
                                {(popupState) => (
                                  <>
                                    <IconButton size="small" {...bindTrigger(popupState)}>
                                      <MoreVert fontSize="small" />
                                    </IconButton>
                                    <Menu {...bindMenu(popupState)}>
                                      <MenuItem onClick={openEditForm(row.id, popupState.close)}>
                                        {" "}
                                        <FormattedMessage {...messages.editButton} />
                                      </MenuItem>
                                      <MenuItem key={row.id} onClick={handleOpenDialog(row, popupState.close)}>
                                        {" "}
                                        <FormattedMessage {...messages.deleteButton} />
                                      </MenuItem>
                                    </Menu>
                                  </>
                                )}
                              </PopupState>
                              <Modal
                                open={modalState.open && modalState.rowId === row.id}
                                onClose={closeModal}
                                className={classes.modal}
                              >
                                <UserInputForm row={row} variant={modalState.variant} handleCancel={closeModal} />
                              </Modal>
                            </>
                          ) : column.id === "departmentId" ? (
                            <span title={getDepartment(row[column.id])}>{getDepartment(row[column.id])}</span>
                          ) : (
                            <span
                              title={
                                column.id === "registrationDate"
                                  ? moment(row[column.id]).format("YYYY-MM-DD")
                                  : row[column.id]
                              }
                            >
                              {column.id === "registrationDate"
                                ? moment(row[column.id]).format("YYYY-MM-DD")
                                : row[column.id]}
                            </span>
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {rows.length > ROWS_PER_PAGE && (
            <div className={classes.paginationRoot}>
              <Pagination onChange={getCurrentPage} count={Math.ceil(rows.length / ROWS_PER_PAGE)} />
            </div>
          )}
        </div>
        <Dialog open={dialogOpen} onClose={handleCloseDialog}>
          <ConfirmDialog
            content={messages.confirmDialogContent}
            contentValues={{ name: dialogRow && dialogRow.name, surname: dialogRow && dialogRow.surname }}
            actions={{
              yesMessage: messages.confirmDialogBtnYes,
              noMessage: messages.confirmDialogBtnNo,
              handleYes: handleDeleteNews,
            }}
            handleCloseDialog={handleCloseDialog}
          />
        </Dialog>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(AdminBlockPage);
